import React, { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import axios from 'axios';
import google from '../../Assets/google.png';
import AuthLayout from '../shared/AuthLayout';
import SignupFormEmail from './email';
import SignupFormPhone from './phone';

const SignupPage = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    username: '',
    confirm_password: '',
    phone_number: '',
    otp: '',
  });

  const [SignupMethod, setSignupMethod] = useState('email');
  const [otpSent, setOtpSent] = useState(false);
  const [timer, setTimer] = useState(60);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    if (otpSent && timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [otpSent, timer]);

  const handleSignup = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    try {
      if (SignupMethod === 'email') {
        await axios.post('http://127.0.0.1:8000/login/register', {
          email: formData.email,
          password: formData.password,
          confirm_password: formData.confirm_password,
        });
        setSuccess('Signup successful!');
      } else {
        await axios.post('http://127.0.0.1:8000/login/send-otp', {
          phone_number: formData.phone_number,
        });
        setOtpSent(true);
        setSuccess('OTP sent to your phone number!');
      }
    } catch (err) {
      setError('Error during signup. Please try again.');
    }
  };

  const handleMethodChange = (method) => {
    setSignupMethod(method);
    setFormData({
      email: '',
      password: '',
      username: '',
      confirm_password: '',
      phone_number: '',
      otp: '',
    });
    setOtpSent(false);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <AuthLayout
      heading="Create an account"
      subheading="Let's get started with your 30 day free trial."
      footerPrompt="Already have an account?"
      footerLinkLabel="Log in"
      footerLinkTo="/login"
    >
      <Button
        startIcon={<Box component="img" src={google} alt="" aria-hidden="true" sx={{ width: 20, height: 20 }} />}
        fullWidth
        sx={{
          borderRadius: 999,
          py: 1.2,
          textTransform: 'none',
          fontWeight: 600,
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
          '&:hover': { boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' },
        }}
      >
        Sign up with Google
      </Button>

      <Typography sx={{ textAlign: 'center', my: 2, fontSize: 14, color: 'text.secondary' }}>or</Typography>

      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{
          width: '100%',
          borderRadius: '30px',
          overflow: 'hidden',
          background: '#F2F6FF',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
          mb: 2.5,
        }}
      >
        <Box
          sx={{
            flex: 1,
            padding: '10px',
            textAlign: 'center',
            cursor: 'pointer',
            borderRadius: '30px',
            backgroundColor: SignupMethod === 'email' ? 'white' : '#F2F6FF',
            color: SignupMethod === 'email' ? 'black' : 'grey',
            fontSize: 13,
            fontWeight: 600,
            transition: 'background-color 0.3s ease-in-out, color 0.3s ease-in-out',
          }}
          onClick={() => handleMethodChange('email')}
        >
          Sign up with Email
        </Box>
        <Box
          sx={{
            flex: 1,
            padding: '10px',
            textAlign: 'center',
            cursor: 'pointer',
            borderRadius: '30px',
            backgroundColor: SignupMethod === 'phone' ? 'white' : '#F2F6FF',
            color: SignupMethod === 'phone' ? 'black' : 'grey',
            fontSize: 13,
            fontWeight: 600,
            transition: 'background-color 0.3s ease-in-out, color 0.3s ease-in-out',
          }}
          onClick={() => handleMethodChange('phone')}
        >
          Sign up with Phone
        </Box>
      </Box>

      <form onSubmit={handleSignup} style={{ width: '100%' }}>
        {SignupMethod === 'email' ? (
          <SignupFormEmail formData={formData} handleChange={handleChange} handleSubmit={handleSignup} />
        ) : (
          <SignupFormPhone
            formData={formData}
            handleChange={handleChange}
            otpSent={otpSent}
            timer={timer}
            setOtpSent={setOtpSent}
            setTimer={setTimer}
            handleSubmit={handleSignup}
          />
        )}

        <Box mt={2}>
          {error && <Typography color="error" sx={{ fontSize: 13.5 }}>{error}</Typography>}
          {success && <Typography color="success.main" sx={{ fontSize: 13.5 }}>{success}</Typography>}
        </Box>
      </form>
    </AuthLayout>
  );
};

export default SignupPage;
